<template>
    <div class="against-bttn wd-ht-px-60 br-rd-pr-50 dp-fx fx-al-ct fx-js-ct cs-ptr bttn">
        <img src="@/assets/nope.png" v-on:click="$emit('against-button-clicked')"/>
    </div>
</template>

<script>
    export default {
        name : 'AgainstButton',
    }
</script>

<style lang="scss">
    .wd-ht-px-60{
        width: 60px;
        height: 60px;
    }
    .against-bttn{
        background: linear-gradient(135deg, #09E297 0%, #08B05D 100%);
    }
    .against-bttn img {
        width: 22px;
    }
    .bttn.bttn-disable{
        pointer-events: none;
    }
    .against-bttn.bttn-disable{
        background: linear-gradient(135deg, #C1E0D5 0%, #5AA17D 100%);
    }
</style>